$(document).ready(function() {
  window.initialize()
});

$(document).on('turbo:render', function() {
  window.initialize()
});

$(document).on('shown.bs.modal', function (event) {
  window.initialize()
})

$(document).on('cocoon:after-insert', function() {
  window.initialize()
});

window.initialize = function() {
  document.dispatchEvent(new Event("initialize"));
}
